import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { usePortal } from "../../context/PortalsContext";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import { hasAnyRole } from "../../utils/roleUtils";
import { Roles } from "../../services/api/types/users/users";

interface ProtectedRouteProps {
  allowedRoles: Roles[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowedRoles,
}) => {
  const { auth } = useAuth();
  const { portals } = usePortal();
  const { user, loadStatus } = auth;

  if (!user && loadStatus === "loaded") return <Navigate to="/login" replace />;

  if (user) {
    const hasAccess = hasAnyRole(user, portals.selectedPortal, allowedRoles);

    if (!hasAccess) return <Navigate to="/home" replace />;
  }

  return (
    <PageLayout>
      <Outlet />
    </PageLayout>
  );
};
